import { X } from "lucide-react";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from "react-redux";


const PurReceiveFields = ({ form, handleChange, handlePdf, error, data }) => {
  const receivedByData =
    useSelector((state) => state.getGenMaster?.user?.data) || [];
  const projectData =
    useSelector((state) => state.getProject?.user?.data) || [];
  const partyData = useSelector((state) => state.getParty?.user?.data) || [];
  const transportData =
    useSelector((state) => state.getTransport?.user?.data) || [];

  const selectedProject = projectData.find((p) => p._id === form.project_id);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Project <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.project_id}
              options={projectData?.map((e) => ({
                label: e.project_no ? `${e.name} (${e.project_no})` : e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "project_id", value: e.value } })
              }
              placeholder="Select Project"
              filter
              className="w-100"
              disabled={data?._id}
            />
            <div className="error">{error?.project_id}</div>
          </div>
        </div>
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Project No</label>
            <input
              type="text"
              name="manual_pro_no"
              placeholder="Enter Project No"
              value={form?.manual_pro_no || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div> */}
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Party <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.party_id}
              options={partyData?.map((e) => ({ label: e.name, value: e._id }))}
              onChange={(e) =>
                handleChange({ target: { name: "party_id", value: e.value } })
              }
              placeholder="Select Party"
              filter
              className="w-100"
              disabled={data?._id}
            />
            <div className="error">{error?.party_id}</div>
          </div>
        </div>
        {data?._id && (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms">
              <label>Received No.</label>
              <input
                type="text"
                className="form-control"
                value={data?.voucher_no}
                readOnly
              />
            </div>
          </div>
        )}
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Date <span className="login-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="trans_date"
              onChange={handleChange}
              value={form.trans_date}
            />
            {error.trans_date && (
              <div className="error">{error.trans_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Receiving Date <span className="login-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="receive_date"
              onChange={handleChange}
              value={form.receive_date}
            />
            {error.receive_date && (
              <div className="error">{error.receive_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              Received By <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.master_id}
              options={receivedByData?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({ target: { name: "master_id", value: e.value } })
              }
              placeholder="Select Received By"
              filter
              className="w-100"
            />
            {error.master_id && <div className="error">{error.master_id}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              {" "}
              Bill No. <span className="login-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="bill_no"
              onChange={handleChange}
              value={form.bill_no}
            />
            {error.bill_no && <div className="error">{error.bill_no}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              {" "}
              Challan No. <span className="login-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="challan_no"
              onChange={handleChange}
              value={form.challan_no}
            />
            {error.challan_no && (
              <div className="error">{error.challan_no}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Loading Amount
            </label>
            <input
              type="number"
              className="form-control"
              name="loading_amount"
              onChange={handleChange}
              value={form.loading_amount}
            />
            {error.loading_amount && (
              <div className="error">{error.loading_amount}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>
              Freight Amount
            </label>
            <input
              type="number"
              className="form-control"
              name="freight_amount"
              onChange={handleChange}
              value={form.freight_amount}
            />
            {error.freight_amount && (
              <div className="error">{error.freight_amount}</div>
            )}
          </div>
        </div>
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>
              {" "}
              Transport <span className="login-danger">*</span>
            </label>
            <Dropdown
              value={form.transport_id}
              options={transportData?.map((e) => ({
                label: e.name,
                value: e._id,
              }))}
              onChange={(e) =>
                handleChange({
                  target: { name: "transport_id", value: e.value },
                })
              }
              placeholder="Select Transport"
              filter
              className="w-100"
            />
            {error.transport_id && (
              <div className="error">{error.transport_id}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Transport Date </label>
            <input
              type="date"
              className="form-control"
              name="transport_date"
              onChange={handleChange}
              value={form.transport_date}
            />
            {error.transport_date && (
              <div className="error">{error.transport_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> LR No. </label>
            <input
              type="text"
              className="form-control"
              name="lr_no"
              onChange={handleChange}
              value={form.lr_no}
            />
            {error.lr_no && <div className="error">{error.lr_no}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>LR Date</label>
            <input
              type="date"
              className="form-control"
              name="lr_date"
              onChange={handleChange}
              value={form.lr_date}
            />
            {error.lr_date && <div className="error">{error.lr_date}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> Vehicle No.</label>
            <input
              type="text"
              className="form-control"
              name="vehical_no"
              onChange={handleChange}
              value={form.vehical_no}
            />
            {error.vehical_no && (
              <div className="error">{error.vehical_no}</div>
            )}
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label> Driver Name </label>
            <input
              type="text"
              className="form-control"
              name="driver_name"
              onChange={handleChange}
              value={form.driver_name}
            />
            {error.driver_name && (
              <div className="error">{error.driver_name}</div>
            )}
          </div>
        </div> */}
        {/* <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Payment Date</label>
            <input
              type="date"
              className="form-control"
              name="payment_date"
              onChange={handleChange}
              value={form.payment_date}
            />
            {error.payment_date && (
              <div className="error">{error.payment_date}</div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Payment Days </label>
            <input
              type="number"
              className="form-control"
              name="payment_days"
              onChange={handleChange}
              value={form.payment_days}
            />
            {error.payment_days && (
              <div className="error">{error.payment_days}</div>
            )}
          </div>
        </div> */}
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-top-form">
            <label className="local-top">PDF </label>
            <div className="settings-btn upload-files-avator">
              <label htmlFor="pdfFile" className="upload">
                Choose PDF File(s)
              </label>
              <input
                key={form.pdf}
                type="file"
                id="pdfFile"
                onChange={handlePdf}
                name="pdf"
                accept="application/pdf,image/*"
                className="hide-input"
              />
            </div>
            {error.pdf && <div className="error">{error.pdf}</div>}

            {form.pdf && (
              <div
                className="mt-2"
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <a
                  href={form.pdf}
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: "block" }}
                >
                  {form.pdf.endsWith(".pdf") ? (
                    <img src="/assets/img/pdflogo.png" alt="pdf-icon" />
                  ) : (
                    <img
                      src={form.pdf}
                      alt="uploaded-img"
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "9px",
                      }}
                    />
                  )}
                </a>

                {form.pdf.endsWith(".pdf") ? (
                  <button
                    type="button"
                    className="btn bg-light"
                    onClick={() =>
                      handleChange({
                        target: { name: "pdf", value: "" },
                      })
                    }
                    style={{
                      position: "absolute",
                      top: "5px",
                      left: "45px",
                      color: "red",
                      border: "1px solid red",
                      padding: "1px 1px",
                      borderRadius: "7px",
                      minWidth: "22px",
                      height: "22px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                    title="Remove file"
                  >
                    <X size={14} />
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn bg-light"
                    onClick={() =>
                      handleChange({
                        target: { name: "pdf", value: "" },
                      })
                    }
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      color: "red",
                      padding: "4px 3px",
                      borderRadius: "7px",
                      minWidth: "30px",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                    title="Remove file"
                  >
                    <X size={20} />
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="input-block local-forms">
            <label>Reason/Purpose</label>
            <textarea
              type="text"
              className="form-control"
              rows={4}
              onChange={handleChange}
              name="remarks"
              placeholder="Remarks"
              value={form.remarks}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PurReceiveFields;
